export const allFoldersInArchive = "Pcb";
export const allFoldersString = "Qcb";
export default {allFoldersInArchive,allFoldersString};